class OpenShopifyChatWidget extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-shopify-chat-open]');
    this.isChatLoaded = false;
    this.isButtonClicked = false;

    this.button.addEventListener('click', () => this.handleButtonClick());

    this.observeChatLoading();
  }

  /**
   * handleButtonClick
   * @description Handles the click event on a button that opens the Shopify chat.
   * If the chat is already loaded, it toggles the chat. Otherwise, it marks the button as loading
   */
  handleButtonClick() {
    if (this.isChatLoaded) return this.openChat();

    // handles the chat being open already
    if (document.querySelector('inbox-online-store-chat')?.getAttribute('is-open') === 'true') {
      return (this.isChatLoaded = true);
    }

    // handles the chat not being loaded yet
    this.button.classList.add('loading');
    this.isButtonClicked = true;
  }

  /**
   * openChat
   * @description Opens the Shopify chat by clicking the chat-toggle element.
   */
  openChat() {
    const inboxOnlineStoreChat = document.querySelector('inbox-online-store-chat');
    const shadow = inboxOnlineStoreChat?.shadowRoot;
    shadow?.querySelector('.chat-toggle')?.click();

    // remove the loading class from the button
    this.button.classList.remove('loading');
  }

  /**
   * observeChatLoading
   * @description Observes the document body for changes to detect when the Shopify chat widget is loaded.
   * Once the chat widget is found, it sets isChatLoaded to true, processes any previously clicked buttons,
   * and disconnects the observer.
   */
  observeChatLoading() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeName.toLowerCase() === 'inbox-online-store-chat') {
              // Wait for the shadow root to be available and check for .chat-toggle
              const checkShadowRoot = setInterval(() => {
                const shadow = node.shadowRoot;
                if (shadow && shadow.querySelector('.chat-toggle')) {
                  this.isChatLoaded = true;

                  if (this.isButtonClicked) this.openChat();

                  observer.disconnect();
                  clearInterval(checkShadowRoot);
                }
              }, 100);

              // Clear interval after 5 seconds if element is not found
              setTimeout(() => clearInterval(checkShadowRoot), 5000);
            }
          });
        }
      });
    });

    // start observing the document body for changes
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
}

customElements.define('open-shopify-chat-widget', OpenShopifyChatWidget);
